import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faUndo, faUsers } from "@fortawesome/free-solid-svg-icons";
const token = localStorage.getItem('token');

const TrashClients = () => {
  const [deletedClients, setDeletedClients] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchDeletedClients();
  }, []);

  const fetchDeletedClients = async () => {
    try {
      const res = await axios.get(`/client?withDeleted=true`, {
        headers: {
          Authorization:
            `Bearer ${token}`,
        },
      });
      const onlyDeleted = res.data.filter((p) => p.deletedAt != null);
      setDeletedClients(onlyDeleted);
    } catch (error) {
      console.error("Erreur lors du chargement des clients supprimés", error);
    }
  };
  const handleRestore = async (id) => {
    try {
      await axios.patch(`/client/recover/id/${id}`, null, {
        headers: {
          Authorization:
            `Bearer ${token}`,
        },
      });

      setDeletedClients((prev) => prev.filter((client) => client.id !== id));
    } catch (error) {
      console.error("Erreur lors de la restauration du client", error);
    }
  };

  return (
    <div className="p-6">
    <div className="top-bar">
        <h3>Clients supprimés</h3>
      <div>
      <button onClick={() => navigate("/admin/clients")} className="bout-trash">
        <FontAwesomeIcon icon={faUsers} style={{ marginRight: "8px" }} /> 
        Liste des projets
      </button>
      </div></div>

      <table className="w-full border-collapse">
        <thead>
          <tr>
              <th className="p-2 border">Nom</th>
              <th className="p-2 border">E-mail</th>
              <th className="p-2 border">Poste</th>
              <th className="p-2 border">Projets associés</th>
            </tr>
        </thead>
        <tbody>
          {deletedClients.length > 0 ? (
            deletedClients.map((client) => (
              <tr key={client.id}>
                  <td className="p-2 border">{client.name}</td>
                  <td className="p-2 border">{client.email}</td>
                  <td className="p-2 border">{client.jobTitle}</td>
                  <td className="p-2 border">
                  <ul>
                    {client.projects.map((p) => (
                      <li key={p.id}>{p.projectName}</li>))}
                  </ul>
                  </td>
                <td className="border px-4 py-2">
                  <button
                    onClick={() => handleRestore(client.id)}
                    className="icon-button text-red-600"
                  >
                    <FontAwesomeIcon icon={faUndo} />
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td className="text-center p-4" colSpan={6}>
                Aucun client supprimé.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TrashClients;
